module.exports = __webpack_public_path__ + "media/images/desktop/messenger-icon-154ec1b4f0861d568375694bb95fd5ca.svg";